// data-testid constants for ImageKitHub features
export const NAV = {
  logo: "nav-logo",
  home: "nav-home",
  tools: "nav-tools",
  blog: "nav-blog",
  about: "nav-about",
  contact: "nav-contact",
  themeToggle: "nav-theme-toggle",
  search: "nav-search-input",
  mobileMenu: "nav-mobile-menu",
  adminLogin: "nav-admin-login",
};

export const HOME = {
  emergentLink: 'home-emergent-link',
  heroTitle: "home-hero-title",
  heroSearch: "home-hero-search",
  ctaExplore: "home-cta-explore",
  newsletterEmail: "home-newsletter-email",
  newsletterSubmit: "home-newsletter-submit",
};

export const TOOL = {
  uploadInput: "tool-upload-input",
  uploadButton: "tool-upload-button",
  processButton: "tool-process-button",
  downloadButton: "tool-download-button",
  resetButton: "tool-reset-button",
  ratingStar: "tool-rating-star",
};

export const ADMIN = {
  loginButton: "admin-login-button",
  logoutButton: "admin-logout-button",
  createPostButton: "admin-create-post",
  postSlugInput: "admin-post-slug",
  postTitleInput: "admin-post-title",
  postExcerptInput: "admin-post-excerpt",
  postContentInput: "admin-post-content",
  postCategoryInput: "admin-post-category",
  savePostButton: "admin-save-post",
};
